import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./header";
import ErrorPage from "../pages/error";
import Home from "../pages/home";

const Routing = ({ soundEnabled, setSoundEnabled }) => {
  return (
    <BrowserRouter>
      <Header
        soundEnabled={soundEnabled}
        onToggleSound={() => setSoundEnabled((current) => !current)}
      />

      <Routes>
        <Route
          path="/"
          element={
            <Home
              setSoundEnabled={setSoundEnabled}
              soundEnabled={soundEnabled}
            />
          }
        />
        <Route path='*' element={<ErrorPage />}/>
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
